<template>
  <div class="mt-5 mb-3">
    <fieldset :disabled="submitalLocked" style="min-height: calc(100vh - 330px);">
      <General
        ref="currentStepComponent"
        v-if="currentStep === 'general'"
        :update-configurable="updateConfigurable"
        @show-alert="displayAlert"
        @update-submital="updateSubmital"
      />
      <DoorType v-if="currentStep === 'door_type'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Dimensions v-if="currentStep === 'dimensions'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Components v-if="currentStep === 'components'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Electrical v-if="currentStep === 'electrical'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Limitations v-if="currentStep === 'limitations'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
    </fieldset>

    <ConfiguratorStepButtons
      v-if="currentStep !== 'color-selector'"
      :is-first-step="isFirstStep"
      :is-last-step="isLastStep"
      @saveStepData="handleStepSave"
    />

    <!-- Alert -->
    <ToastAlert :show="alertShow" :variant="alertVariant" @close="alertShow = false">
      {{ alertMessage }}
    </ToastAlert>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ToastAlert from '../../../../components/shared/ToastAlert'

import ConfiguratorStepButtons from '../ConfiguratorStepButtons.vue'
import General from './General'
import DoorType from './DoorType'
import Dimensions from './Dimensions'
import Components from './Components'
import Electrical from './Electrical'
import Limitations from './Limitations'

export default {
  name: 'Configurator',
  components: {
    General,
    DoorType,
    Dimensions,
    Components,
    Electrical,
    Limitations,
    ConfiguratorStepButtons,
    ToastAlert
  },
  data () {
    return {
      submitalId: Number(this.$route.params.id),
      updatingSubmital: false,
      updatingConfigurable: false,
      alertShow: false,
      alertVariant: null,
      alertMessage: ''
    }
  },
  computed: {
    ...mapState({
      currentStep: state => state.configurator.currentStep
    }),
    ...mapGetters(['configurableId', 'isFirstStep', 'isLastStep', 'submitalLocked']),
    processing () {
      return this.updatingSubmital || this.updatingConfigurable
    }
  },
  methods: {
    updateConfigurable (formData) {
      if (this.submitalLocked) {
        return true
      }

      if (this.updatingConfigurable || Object.keys(formData).length === 0) return false
      this.updatingConfigurable = true
      return this.$http.patch(`/api/production/submitals/${this.$route.params.id}/puertas_automaticas/${this.configurableId}`, {
        automatic_door: { ...formData }
      })
        .then((res) => {
          this.$store.commit('setConfigurable', res.data)
          this.$store.commit('setSubmital', res.data.submital)
          return true // this is needed in handleStepSave to continue
        })
        .catch(() => false)
        .finally(() => this.updatingConfigurable = false)
    },
    updateSubmital (formData) {
      if (this.submitalLocked) {
        return true
      }

      if (this.updatingSubmital || !formData || Object.keys(formData).length === 0) { return }
      this.updatingSubmital = true
      this.$http.patch(`/api/production/submitals/${this.$route.params.id}`, {
        submital: { ...formData }
      })
      .then((res) => {
        // console.log('Submital updated', res.data)
        this.$store.commit('setSubmital', res.data)
      })
      .finally(() => this.updatingSubmital = false)
    },
    async handleStepSave (action) {
      const stepComponent = this.$refs.currentStepComponent

      if (!stepComponent) {
        console.warn('No step component defined')
        return
      }

      if (!stepComponent?.update) {
        console.warn('No update method defined in current step component')
        return
      }

      const successResponse = await stepComponent.update()

      if (!successResponse) {
        if (this.submitalLocked) {
          this.displayAlert({ message: 'El submital está bloqueado y no puede editarse', variant: 'danger', time: 4000 })
          return
        }

        this.displayAlert({ message: 'Hubo un error al guardar cambios, intente de nuevo', variant: 'danger', time: 4000 })
        return
      }

      if (action === 'approve') {
        this.$router.push({ name: 'SubmitalShow', params: { id: this.submitalId }})
        return
      }

      // Go to step
      this.$store.dispatch(action)
    },
    displayAlert ({ message, variant, time=2000 }) {
      this.alertVariant = variant
      this.alertMessage = message
      this.alertShow = true
      setTimeout(() => this.alertShow = false, time)
    }
  }
}
</script>
